<div class="test-list-page">
  <div class="header">
    <div class="dashboard-breadcrumb-wrapper">
      <nrwl-breadcrumb></nrwl-breadcrumb>
    </div>
    <div class="refresh-btn">
      <button mat-raised-button class="btn" (click)="refreshTestList()">REFRESH</button>
    </div>
  </div>
  <progress-spinner *ngIf="isLoading"> </progress-spinner>
  <div class="no-results" *ngIf="!isDataAvailable && !isLoading">No records found</div>
  <div class="content-summary">
    <div>
      <div class="views">
        <div class="view">
          <test-list-table
            [data]="dataSource"
            [refreshTable]="refreshTable"
            [widgetData]="dataConfig.widget"
            [layeredSource]="layeredSource"
            (hasData)="hasData($event)"
            [columnHeader]="columnHeader"
            [tableId]="tableId"
          ></test-list-table>
        </div>
      </div>
    </div>
  </div>
</div>
